import cx from 'classnames'
import * as React from 'react'

import { CalculatorInputViewModel } from '../../../view-models/CalculatorInputViewModel'

import { infoCircle } from '../../../icons'
import Button from '../../_legacy/Button'
import styles from './calculatorInput-style.css'
import { InfoButton } from '@/components/Button/InfoButton'
import Icon from '@/components/Icon/Icon'

//TODO: Seems like it still works!
type Props = CalculatorInputViewModel & {
  value: string
  handleClick: (...args: any[]) => any
  handleChange: (...args: any[]) => any
  id: string | number
}

function CalculatorInput({
  label,
  placeholder,
  value,
  handleChange,
  handleClick,
  id,
}: Props) {
  const idRef: React.MutableRefObject<any> = React.useRef()
  let calculatorId = typeof id === 'string' ? parseInt(id as string) : id
  if (!idRef.current) idRef.current = calculatorId++
  if (!handleChange) return null

  return (
    <div className={styles.calculatorInput}>
      {label && <label htmlFor={idRef.current}>{label}</label>}
      <div className={styles.holder}>
        <span className={cx(styles.currencyBox, styles.inputBox)}>DKK</span>
        <input
          id={idRef.current}
          type="number"
          value={value}
          placeholder={placeholder}
          onChange={handleChange}
        />
        <div className={styles.iconWrapper}>
          <InfoButton onClick={handleClick} className={styles.infoBtn}>
            <Icon iconSrc={infoCircle} />
          </InfoButton>
        </div>
      </div>
    </div>
  )
}

CalculatorInput.displayName = 'CalculatorInput'
CalculatorInput.defaultProps = {}
export default CalculatorInput
